import { IRawData } from './DoyPrediction';

export interface IPercents_v0 {
	day: Date,
	percent_increase: number,
}

export interface IPrediction_v0 {
	id: string,
	schema_version: string,
	name: string,
	latitude: number,
	longitude: number,
	country: string,
	country_code: string,
	city: string,
	postalcode: string,
	formatted_address: string,
	bestdays: IPercents_v0[],
	bestcollection: IPercents_v0[],
	rawdata?: IRawData[],

	modifiedTimstamp: string,
}

export const DefaultPrediction: IPrediction_v0 = {
	id: '',
	schema_version: '',
	name: '',
	latitude: 0,
	longitude: 0,
	country: '',
	country_code: '',
	city: '',
	postalcode: '',
	formatted_address: '',
	bestdays: [],
	bestcollection: [],

	modifiedTimstamp: '',
}